// CHEAT SHEET: https://gist.github.com/mrmartineau/a4b7dfc22dc8312f521b42bb3c9a7c1e
import AdvancedController from "./advanced-controller"
import lunr from 'lunr'

export default class FaqSearchController extends AdvancedController {

  static targets = [
    "q",
    "messageError"
  ];

  static values = {
    // TODO: use or remove
    // exampleString: String,
    // exampleDefault: { type: Number, default: 42 },
  }

  connect() {
    super.connect(...arguments)
    // TODO: use or remove
    this._isInitialized = false;
  }

  onSearchSubmit(e) {
    e.preventDefault();
    if (!this._isInitialized) {
      this.initialize();
    }

    this.hideMessages();

    const q = this.qTarget.value;

    const results = this.idx.search(q)

    this.processResults(results, q)
  }

  onClear(e) {
    e.preventDefault();
    this.hideMessages();
    this.qTarget.value = "";
    this.showAllExpandables();
  }

  initialize() {
    const query = this.getAllExpandables();
    const documents = []

    for (const expandable of [...query]) {
      const blockId = expandable.id;
      const headline = expandable.querySelector('.expandable__title');
      const content = expandable.querySelector('.expandable__content');

      const document = {
        id: blockId,
        headline: headline.innerText,
        content: content.innerText
      }

      documents.push(document)
    }

    this.idx = lunr(function () {
      this.ref('id')
      this.field('headline')
      this.field('content')

      documents.forEach(function (doc) {
        this.add(doc)
      }, this)
    })
  }

  getAllExpandables() {
    return [...(this.element.querySelectorAll('.block__expandable'))]
  }

  showAllExpandables() {
    for (const expandable of this.getAllExpandables()) {
      expandable.classList.remove('-hidden');
      expandable.style.order = 'initial';
    }
  }

  hideAllExpandables() {
    for (const expandable of this.getAllExpandables()) {
      expandable.classList.add('-hidden');
    }
  }

  processResults(results, q) {
    this.showAllExpandables();
    if (!results || results.length === 0) {
      this.hideAllExpandables();
      this.messageErrorTarget.classList.remove('-hidden');
    } else {
      // matches
      this.hideAllExpandables();
      let i = 0
      for (const match of results) {
        i = i + 1
        const sel = `#${match.ref}`
        const expandable = this.element.querySelector(sel)
        expandable.style.order = i
        expandable.classList.remove('-hidden')
      }
    }
  }

  hideMessages() {
    this.messageErrorTarget.classList.add('-hidden');
  }

}
